import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface DefectCausesService {
  getDefectCauseSelections(defectTypeId: string): angular.IPromise<apsViewModels.DefectCauseSelection[]>;
  getCourseOfActions(): angular.IPromise<apsViewModels.CourseOfActionSelection[]>;
  addDefectCause(defectTypeCommand: apsCommands.AddDefectCause): angular.IPromise<any>;
  submitDefectCause(defectTypeCommand: apsCommands.EditDefectCause): angular.IPromise<any>;
}

export default angular
  .module('aps.services.defectCauses', [HttpServiceName])
  .service('defectCausesService', function(httpService: HttpService): DefectCausesService {

    var getDefectCauseSelections = (defectTypeId: string) => {
      return httpService
        .get<apsViewModels.DefectCauseSelection[]>(Endpoints.DEFECT_CAUSES.replace('{id}', defectTypeId));
    };

    var submitDefectCause = (defectTypeCommand: apsCommands.EditDefectCause) => {
      var url = Endpoints.DEFECT_CAUSE_DETAILS.replace('{0}', defectTypeCommand.id);
      return httpService.post(url, defectTypeCommand);
    };

    var addDefectCause = function(defectTypeCommand: apsCommands.AddDefectCause) {
      var url = Endpoints.DEFECT_CAUSE_ADD;
      return httpService.post(url, defectTypeCommand);
    };

    var getCourseOfActions = () => {
      var url = Endpoints.COURSE_OF_ACTION;
      return httpService.get<apsViewModels.CourseOfActionSelection[]>(url);
    };

    return {
      getDefectCauseSelections: getDefectCauseSelections,
      getCourseOfActions: getCourseOfActions,
      submitDefectCause: submitDefectCause,
      addDefectCause: addDefectCause
    };
  })
  .name;




// WEBPACK FOOTER //
// ./src/app/services/defectCauses/defectCause.service.ts